const domains = {
  api: process.env.VUE_APP_ROOT_API,
  gallery: process.env.VUE_APP_GALLERY_URL,
  download: process.env.VUE_APP_DOWNLOAD_URL,
};
export default domains.api;
export { domains };
